import { FC, useEffect, useRef, useState } from 'react';
import { displayProtectedImage } from 'untils/getFile';
import { onHttp } from 'untils/onHttp';

interface IProps {
  hash: string;
  endpoint?: string;
  type?: string;
}

export const Video: FC<IProps> = ({ hash, type, endpoint = '/storage/photo' }) => {
  const refVideo = useRef<any>();
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    Number(hash) &&
      refVideo &&
      displayProtectedImage(
        refVideo,
        `${onHttp()}${endpoint}/${hash}`,
        localStorage.getItem('token') || '',
        setLoader,
      );
  }, [refVideo, hash]);

  return (
    <video ref={refVideo} muted autoPlay controls>
      <source type={type} />
    </video>
  );
};
